export default "__VITE_ASSET__CGu_bDDD__"